import { vercelStegaDecode, vercelStegaSplit } from '@vercel/stega';
import classNames from 'classnames';
import ReactMarkdown from 'react-markdown';

import {
  createMarkdownComponents,
  MARKDOWN_REHYPE_PLUGINS,
  MARKDOWN_REMARK_PLUGINS,
} from '~components/Markdown/markdownComponents';

import styles from './Markdown.module.scss';
import { PreviewMarkdown } from './PreviewMarkdown';
import { MarkdownProps } from './types';

type StrapiSource = { strapiSource?: string };

const splitStrapiSource = (markdown: string) => {
  try {
    const { cleaned, encoded } = vercelStegaSplit(markdown);
    const source = encoded
      ? vercelStegaDecode<StrapiSource>(encoded)?.strapiSource
      : undefined;
    return { cleaned, source };
  } catch {
    return { cleaned: markdown, source: undefined };
  }
};

export function Markdown({
  markdownString,
  className,
  components,
  children,
}: MarkdownProps) {
  const markdown = children || markdownString;

  if (!markdown) {
    return null;
  }

  const { cleaned, source } = splitStrapiSource(markdown);

  if (source) {
    return (
      <PreviewMarkdown
        source={source}
        markdown={cleaned}
        className={className}
      />
    );
  }

  return (
    <ReactMarkdown
      className={classNames(styles.markdown, className)}
      remarkPlugins={MARKDOWN_REMARK_PLUGINS}
      rehypePlugins={MARKDOWN_REHYPE_PLUGINS}
      components={createMarkdownComponents(undefined, components)}
    >
      {cleaned}
    </ReactMarkdown>
  );
}
